__turbopack_context__.v({
  "slide": "FeaturedBlogsSection-module-scss-module__-qo4va__slide",
});
